<script setup>
  import { ref, computed } from 'vue';
  import { useCart } from '@storefront/storefront';

  const show = ref(false);
  const { cart } = useCart();

  const total = computed(() => {
    if (cart.value) {
      return cart.value.totalGross;
    }

    return 0;
  });

  const currency = computed(() => {
    if (cart.value) {
      return cart.value.currency.code;
    }
  });

  const decimals = computed(() => {
    if (cart.value) {
      return cart.value.currency.decimals;
    }
  });

  function open() {
    show.value = true;
  }
</script>
<template>
  <SfButton transparent class="mini-cart-button" aria-labelledby="mini-cart-label" @click="open" @keydown.enter.prevent="open" aria-haspopup="dialog" aria-controls="drawer-cart-drawer">
    <template #before>
      <SfIconCartHeader aria-hidden="true" />
    </template>
    <span id="mini-cart-label">
      <span class="mini-cart-button__label-sr-only">
        {{ $t('SHOP.COMMON.ACTION.OPEN_CART') }}
      </span>
      <SfMoney :code="currency" :decimals="decimals" :value="total" />
    </span>
  </SfButton>
  <SfDrawerCart v-model:open="show" />
</template>
<style lang="scss" scoped>

  .mini-cart-button__label-sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip-path: inset(50%);
    white-space: nowrap;
    border: 0;
  }

  #mini-cart-label{
    display: contents;
  }

  @media(max-width: 767px) {
    .mini-cart-button {
      padding-right: 0.25rem;
    }
  }
</style>
